// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 424) return "static/chunks/181c7756-65102dd077f9e55f.js";
	if (chunkId === 867) return "static/chunks/867-f5461fab63c26d66.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"1b620d201c974ee9","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"c03c6c67b689b564","367":"ae81691f04bbc34d","639":"7e1b22c1eaec6b80","748":"3517bf99dad5c19e"}[chunkId] + ".js";
};